<template>
  <section class="pt-5 d-flex flex-column">
    <div class="text-center pt-5 mt-5">
      <img class="cloud mt-5 position-relative" src="@/assets/icons/cloud.svg">
      <img class="bazili-handle position-absolute" src="@/assets/Bazili_Handle.png">
    </div>
    <ul class="fallen-container d-flex justify-content-center">
      <li v-for="product in products" :key="product.id" class="fallen-logo">
        <img :src="portalGeneralInfo.cdnAddress + product.icon">
      </li>
    </ul>
    <img class="register-tablet" src="@/assets/icons/tablet.svg">
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RegsiterFormCollection',
  props: {
    products: Array
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  }
}
</script>

<style scoped>
</style>
